import api from './api'

import {trigger, on} from './util/event'

import {replaceAll} from './util/replaceAll'
import main from "./util/main"

const events = {
  show: 'show.kiosk.modal',
  hide: 'hide.kiosk.modal',
  secondaryShow: 'show.kiosk.modal-secondary',
  secondaryHide: 'hide.kiosk.modal-secondary'
}

let openedOnBaseDomain = null,
    openedByHashChange = null;

const $mainModal    = $('#modal'),
      $modalDialog  = $mainModal.find('.modal-dialog'),
      $modalContent = $mainModal.find('.modal-content'),
      $modalBody    = $mainModal.find('.modal-body'),
      iemobile      = /iemobile/i.test(navigator.userAgent),
      iphone        = /iphone/i.test(navigator.userAgent) && !iemobile;

const $secondaryModal        = $('#modal-secondary'),
      $secondaryModalDialog  = $secondaryModal.find('.modal-dialog'),
      $secondaryModalContent = $secondaryModal.find('.modal-content'),
      $secondaryModalBody    = $secondaryModal.find('.modal-body');

const $body = $('body');

// global.$modal = $mainModal;


let mainModalSaveState = false,
  mainModalLoading = false;

const ajaxFormSubmit = function() {
  let form_id = '#' + $(this).attr('id'),
      checkboxes,
      checkboxGroups,
      data,
      submit_button,
      submit_text;

  $(this).find('select').each(function() {
    if ($(this).val() === null) {
      $(this).append('<option value=""></option>').val('');
    }
  });
  checkboxes     = $(this).find('[type=checkbox]');
  checkboxGroups = [];
  checkboxes.each(function() {
    if (checkboxGroups.indexOf($(this).attr('name')) === -1) {
      checkboxGroups.push($(this).attr('name'));
    }
  });
  $(checkboxGroups).each(function() {
    if ($('[name="' + this + '"]:checked').length === 0) {
      let str = this.replace(/[\[\]]/g, '');
      // console.log(str);
      $(form_id).append('<input name="' + str + '" type="text" value="null">');
    }
  });
  data          = $(this).serialize();
  data += '&is_submit=true';
  submit_button = $(this).find('button[type=submit]');
  submit_text   = submit_button.html();
  if (!submit_button.hasClass('loading-accept')) {
    submit_button
      .html('<div class="loader"></div>');
  } else {
    submit_button.addClass('loading');
  }
  submit_button.prop('disabled', true);

  if ($(this).data('emit-event')) {
    trigger($(this).data('emit-event'));
  }

  // api.post($(this).attr('action'), qs.stringify(data))
  api.post($(this).attr('action'), data, {timeout: 5000})
    .then((response) => {

      "use strict";
      const data     = response.data;
      let endLoading = true;
      if (data && data.dontEndLoading) {
        endLoading = false;
      }

      let mul = new Function('form_id, $', '(' + data.callback + ')(form_id, $)');
      mul(form_id, $);

      if (endLoading) {
        if (!submit_button.hasClass('loading-accept')) {
          submit_button.html(submit_text);
        } else {
          submit_button.removeClass('loading');
        }
        submit_button.prop('disabled', false);
      }

    }, () => {

      // console.error('Form save error. Check XHR.');
      // if (!submit_button.hasClass('loading-accept')) {
      //   submit_button.html(submit_text);
      // } else {
      //   submit_button.removeClass('loading');
      // }
      // submit_button.prop('disabled', false);

    }).catch((reason) => {
    console.error(`Form save error. Check XHR. Catch reason ${reason}`);
    if (!submit_button.hasClass('loading-accept')) {
      submit_button.html(submit_text);
    } else {
      submit_button.removeClass('loading');
    }
    submit_button.prop('disabled', false);

  })

  return false;
};

const modalResize = () => {
  const oldHeight = $modalContent.height(),
        height    = $modalContent.css('height', 'auto').outerHeight();
  $modalContent.height(oldHeight);
  $modalContent.animate({height: height}, 500, () => {
    if ($modalContent.outerHeight() > $(window).outerHeight()) {
      $mainModal.css('align-items', 'flex-start');
    } else {
      $mainModal.css('align-items', 'center');
    }
  });
  modalAutofocus();
};

const modalAutofocus = () => {
  $mainModal.modal('handleUpdate');
  const isMobile = window.innerWidth < 768;
  if (!isMobile) {
    const $autofocus = $mainModal.find('input[autofocus]');
    if ($autofocus.length > 0) {
      $autofocus.first().focus();
    }
  }
};

const modalCheckContentSize = () => {
  const $contentHeight  = $modalDialog.height(),
        $viewportHeight = window.innerHeight,
        duration        = 100;

  if ($contentHeight >= $viewportHeight) {
    $modalDialog.addClass('modal-big-size');
    $mainModal.scrollTop(0);

  } else {
    $modalDialog.removeClass('modal-big-size');
  }
}

const secondaryModalAutofocus = () => {
  $secondaryModal.modal('handleUpdate');
  const isMobile = window.innerWidth < 768;
  if (!isMobile) {
    const $autofocus = $secondaryModal.find('input[autofocus]');
    if ($autofocus.length > 0) {
      $autofocus.first().focus();
    }
  }
};

const secondaryModalCheckContentSize = () => {
  const $contentHeight  = $secondaryModalDialog.height(),
        $viewportHeight = window.innerHeight,
        duration        = 100;

  if ($contentHeight >= $viewportHeight) {
    $secondaryModalDialog.addClass('modal-big-size');
    $secondaryModal.scrollTop(0);

  } else {
    // $secondaryModalDialog.removeClass('modal-big-size');
  }
}

const onModalDataLoadDone = (response, href) => {

  mainModalLoading = false

  const data = response.data;
  if (typeof data === 'string') {
    $modalBody.html(data);
    $mainModal.attr('data-href', href);

    // If there's a <title> tag in the header, use it as
    // the page's title.
    const title = $modalBody.find('title').text();

    if (title) {
      document.title = title;
    }

      // Then scrub any titles from their descendants
    $modalBody.find('title').remove()

    if ($mainModal.css('display') === 'none') {
      $mainModal.modal('show');
    } else {
      // modalAutofocus();
      // modalResize();
      $mainModal.trigger('resize.bs.modal');
    }
  } else if (typeof data === 'object') {
    "use strict";
    const mul = new Function('$', '(' + data.callback + ')($)');
    mul($);
  }
}

const showAjaxModal = (href) => {

  if (href === '') {
    $mainModal.is(':visible') && $mainModal.modal('hide');
    return;
  }

  if (window.location.hash !== href) {
    window.location.hash = href;
  }

  href = decodeURIComponent(href.replace(/\+/g, ' '));

  if (window.sidenav !== undefined) {
    window.sidenav.close(); // for mobile || tablet, if already opened
  }

  // TODO cache: false
  api.get(href).then((response) => {
    onModalDataLoadDone(response, href)
  }, (reason) => {

    // TODO - grab in statistics
    // console.log(reason)
  }).catch((reason) => {
    // console.log(reason)
  });

};

const onSecondaryModalDataLoadDone = (response, href) => {

  const data = response.data;

  if (typeof data === 'string') {
    $secondaryModalBody.html(data);
    $secondaryModal.attr('data-href', href);
    if ($secondaryModal.css('display') === 'none') {
      $secondaryModal.modal('show').one('shown.bs.modal', () => {
        if ($mainModal.is(':visible')) {
          mainModalSaveState = true;
          $mainModal.modal('hide').one('hidden.bs.modal', () => {
            $body.addClass('modal-open')
          })
        }
        $body.addClass('modal-open')
      })
    } else {
      // modalAutofocus();
      // modalResize();
      $secondaryModal.trigger('resize.bs.modal');
      if ($mainModal.is(':visible')) {
        mainModalSaveState = true;
        $mainModal.modal('hide').one('hidden.bs.modal', () => {
          $body.addClass('modal-open')
        })
      }
    }

    // ни самом деле нужно ждать пока закончится transition у первого окна и тогда открывать второе

  } else if (typeof data === 'object') {
    "use strict";
    const mul = new Function('$', '(' + data.callback + ')($)');
    mul($);
  }
}

const showAjaxSecondaryModal = (href) => {
  if (href === '') {
    $secondaryModal.is(':visible') && $secondaryModal.modal('hide')
    if (mainModalSaveState) {
      $mainModal.modal('show')
      mainModalSaveState = false
    }
    return
  }

  href = decodeURIComponent(href.replace(/\+/g, ' '));

  // TODO cache: false
  api.get(href).then((response) => {
    onSecondaryModalDataLoadDone(response, href)
  }, (reason) => {

    // TODO - grab in statistics
    // console.log(reason)
  }).catch((reason) => {
    // console.log(reason)
  });

}


// Run

$mainModal
  .on('resize.bs.modal', () => {
    modalAutofocus();
    modalCheckContentSize();
  })
  .on('shown.bs.modal', () => {
    // modalResize();
    modalAutofocus();
    modalCheckContentSize();

    openedOnBaseDomain = true;

  })
  .on('hide.bs.modal', (e) => {

    if (mainModalSaveState) {
      // просто скрываем основное модальное окно и больше ничего не делаем
      return
    }

    let $target        = $(e.target),
        $form          = $target.find('form'),
        redirectOnHide = $form.data('modal-redirect-on-hide'),
        reloadOnHide   = $form.data('reload-on-hide');

    // сразу удалеям чтобы избежать зацикливания
    $form.data('modal-redirect-on-hide', null);

    if (reloadOnHide !== undefined && reloadOnHide === 1) {

      mainModalLoading = true
      openedByHashChange = false
      openedOnBaseDomain = true

      window.location.hash = '';

      window.location.reload(true);
    }

    if (typeof redirectOnHide === 'string' && redirectOnHide.length > 0) {
      e.preventDefault();
      mainModalLoading = true
      openedByHashChange = false
      openedOnBaseDomain = true
      showAjaxModal(redirectOnHide);
      return;
    }

    if ("ga" in window) {
      ga('main.send', 'pageview', location.pathname);
    }


    // если закрытие сделано путем измененя хэша (history.go(-1) - например )
    const url = location.hash.replace(/^#/, '');
    if (url === '') {
      return;
    }

    if (openedOnBaseDomain === true && openedByHashChange === false) {
      window.history.go(-1);
    }
    history.replaceState("", document.title, window.location.pathname + window.location.search);
    return;

    // openedByHashChange = false
    // openedOnBaseDomain = true


    // при закрытии делаем go(-1)
    const historyLength = history.length - (main.ua.platform.type === "desktop" && main.ua.browser.name === "Chrome" ? 1 : 0);

    if (historyLength > 1) {
      window.history.go(-1);
    } else {
      history.replaceState("", document.title, window.location.pathname + window.location.search);
    }

    // if (window.location.hash.length > 0) {
    // history.pushState("", document.title, window.location.pathname + window.location.search);
    // window.location.hash =
    // }

  });


on(events.hide, (e) => {
  $mainModal.modal('hide');
});

on(events.show, (e) => {
  let eventData  = e.detail,
      url        = eventData.url,
      delay      = eventData.delay || 0,
      notOverlay = eventData.notOverlay,
      templates  = {
        '__current_url__': encodeURIComponent(window.location.pathname + window.location.search)
      };

  for (let tpl in templates) {
    if (templates.hasOwnProperty(tpl)) {
      url = replaceAll(url, tpl, templates[tpl]);
      // url = url.replace(tpl, templates[tpl]);
    }
  }

  if (delay === 0) {
    if (notOverlay === true && $mainModal.hasClass('show')) {
      return;
    }
    mainModalLoading = true
    openedByHashChange = false
    openedOnBaseDomain = true
    showAjaxModal(url);
  } else {
    // convert to micros
    delay = parseInt(delay) * 1000;
    setTimeout(() => {
      if (notOverlay === true && $mainModal.hasClass('show')) {
        return;
      }
      mainModalLoading = true
      openedByHashChange = false
      openedOnBaseDomain = true
      showAjaxModal(url);
    }, delay);
  }

});

on(events.secondaryHide, (e) => {
  $secondaryModal.modal('hide').one('hidden.bs.modal', () => {
    $mainModal.is(':visible') && $body.addClass('modal-open')
  })
  // если нужно вернуть обратно главное модальное окно
  if (mainModalSaveState) {
    $mainModal.removeClass('fade').modal('show').one('shown.bs.modal', () => {
      $mainModal.addClass('fade')
      mainModalSaveState = false
    })

  }
})

on(events.secondaryShow, (e) => {
  let eventData  = e.detail,
      url        = eventData.url,
      delay      = eventData.delay || 0,
      notOverlay = eventData.notOverlay,
      templates  = {
        '__current_url__': encodeURIComponent(window.location.pathname + window.location.search)
      };

  for (let tpl in templates) {
    if (templates.hasOwnProperty(tpl)) {
      url = replaceAll(url, tpl, templates[tpl]);
    }
  }

  if (delay === 0) {
    if (notOverlay === true && $secondaryModal.hasClass('show')) {
      return;
    }
    showAjaxSecondaryModal(url);
  } else {
    // convert to micros
    delay = parseInt(delay) * 1000;
    setTimeout(() => {
      if (notOverlay === true && $secondaryModal.hasClass('show')) {
        return;
      }
      showAjaxSecondaryModal(url);
    }, delay);
  }
})

$secondaryModal.on('resize.bs.modal', () => {
  secondaryModalAutofocus();
  secondaryModalCheckContentSize();
})
  .on('shown.bs.modal', () => {
    // modalResize();
    secondaryModalAutofocus();
    secondaryModalCheckContentSize();
  })
  .on('hide.bs.modal', (e) => {
    if (mainModalSaveState) {
      $mainModal.removeClass('fade').modal('show').one('shown.bs.modal', () => {
        $mainModal.addClass('fade')
        $mainModal.is(':visible') && $body.addClass('modal-open')
        mainModalSaveState = false
      })

      $secondaryModal.one('hidden.bs.modal', () => {
        // todo + padding-right 17px
        $mainModal.is(':visible') && $body.addClass('modal-open')
      })
      mainModalSaveState = false
    }
  })


// INIT
$body.on('submit', 'form[data-ajax=true]', ajaxFormSubmit);

if ('onhashchange' in window) {
  const hashHandler = () => {
    const url = location.hash.replace(/^#/, '');
    if (url === '' || url.substr(0, 1) === '/') {
      if (!mainModalLoading) {
        if (!$mainModal.data('hashstable')) {
          openedByHashChange = true
          openedOnBaseDomain = true
          showAjaxModal(url);
        }
      }
    }
  }

  window.addEventListener('hashchange', hashHandler, false)
  hashHandler()
}


const modal = {
  $mainModal: $mainModal,
  $secondaryModal: $secondaryModal,
  showEventName: events.show,
  hideEventName: events.hide
};

export {modal}

export function openModal(url, delay, notOverlay) {
  trigger(events.show, {url: url, delay: delay, notOverlay: notOverlay})
}

export function closeModal() {
  trigger(events.hide, {})
}

export function reloadWindow(url, delay) {
  let _delay = delay || 0;
  if (url === '__current_url__') {
    url = window.location.pathname + window.location.search;
  }

  if (_delay === 0) {
    window.location.href = url;
  } else {
    // convert to micros
    _delay = parseInt(_delay) * 1000;
    setTimeout(function() {
      window.location.href = url;
    }, _delay);
  }
}

export function formSubmit(id) {
  const form = document.querySelector(id);
  if (form !== null) {
    ajaxFormSubmit.call(form)
  }
}

export function openSecondaryModal(url, delay, notOverlay) {
  trigger(events.secondaryShow, {url: url, delay: delay, notOverlay: notOverlay})
}

export function closeSecondaryModal() {
  trigger(events.secondaryHide, {})
}

export {modalResize};
